<template>
  <div id="app">
    <div id="nav" v-if="!quality">
       <!-- <router-link to="/home">丰田中国</router-link> | -->
      <!-- <router-link to="/about">西瓜太郎</router-link> |  -->
      <!-- <router-link to="/case">案件</router-link> |
       <router-link to="/newsCore"><el-badge is-dot class="a">消息</el-badge></router-link> <span v-if="user.type == 1 "> | </span>
       <router-link to="/statisticsData" v-if="user.type == 1">统计</router-link> -->
      <el-radio-group v-model="radio3">
        <el-badge @click.native="changerou('case')" class="a"><el-radio-button label="case">案件</el-radio-button></el-badge>
        <el-badge @click.native="changerou('newsCore')" :is-dot="count>0" class="a"><el-radio-button label="newsCore">消息</el-radio-button></el-badge>
        <el-badge @click.native="changerou('statisticsData')" class="a"  v-if="user.type == 1"><el-radio-button label="statisticsData">统计</el-radio-button></el-badge>
        <el-badge @click.native="changerou('niceCaseList')" class="a"  v-if="user.type == 2"><el-radio-button label="niceCase">好事例</el-radio-button></el-badge>
      </el-radio-group>
      <div>build:{{version}}</div>
    </div>
    <router-view :class="{'view':true, 'views': quality}" @refr="refr"/>
  </div>
</template>
<script>
import { countUnread } from './api/case.js'
export default {
  data () {
    return {
      radio3: '',
      count: 0,
      user: {
        type: 0
      },
      quality: false,
      arr: ['dataList', 'quality', 'qualityUploadData', 'pendingApproval', 'indexMenu'],
      version: ''
    }
  },
  watch: {
    $route (val) {
      console.log(val)
      if (this.arr.includes(val.name)) {
        this.quality = true
      } else {
        this.quality = false
      }
    }
  },
  created () {
    this.version = process.env.VERSION
    if (JSON.parse(localStorage.getItem('user'))) { this.user = JSON.parse(localStorage.getItem('user')) }
    this.radio3 = this.$route.path.substring(1)
    if (this.arr.includes(this.$route.name)) {
      this.quality = true
    }
    this.getCount()
  },
  methods: {
    refr () {
      if (JSON.parse(localStorage.getItem('user'))) { this.user = JSON.parse(localStorage.getItem('user')) }
    },
    changerou (data) {
      this.$router.replace('/' + data)
    },
    getCount () {
      countUnread().then(res => {
        this.count = res.data
      })
    }
  }
}
</script>

<style>
  @import './assets/common.css';
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}
body{
  padding: 0;
}
#nav {
  padding: 30px;
}
#nav a, #nav .a {
  font-weight: bold;
  color: #2c3e50;
  font-size: 18px;
}
#nav a.router-link-exact-active {
  color: #42b983;
}
  input[name=vin]::placeholder{
    color:red !important;
  }
  input[name=vin]::-webkit-input-placeholder{
    color:red !important;
  }
  .message{
    width:20%;
  }
  .el-input.is-disabled .el-input__inner{
    color: #333;
  }
  .el-badge__content.is-fixed.is-dot{
    z-index: 99;
  }
.block .el-input--suffix .el-input__inner{
  padding-right: 5px;
}
</style>
